(function () {
  var api = window.NCFlameAmbiance || {};

  function isYouTubeUrl(url) {
    return /(?:youtube\.com|youtu\.be)/i.test(url || "");
  }

  function getYouTubeId(url) {
    if (!url) return "";

    var patterns = [
      /youtu\.be\/([^?&#/]+)/i,
      /youtube\.com\/watch\?[^#]*v=([^?&#/]+)/i,
      /youtube\.com\/embed\/([^?&#/]+)/i,
      /youtube\.com\/shorts\/([^?&#/]+)/i
    ];

    for (var i = 0; i < patterns.length; i += 1) {
      var match = url.match(patterns[i]);
      if (match && match[1]) return match[1];
    }

    return url;
  }

  function getYouTubeEmbedUrl(url) {
    var id = getYouTubeId(url);
    if (!id) return "";

    return "https://www.youtube.com/embed/" + encodeURIComponent(id) + "?enablejsapi=1&playsinline=1&rel=0&loop=1&playlist=" + encodeURIComponent(id);
  }

  function sendYouTubeCommand(iframe, command, args) {
    if (!iframe || !iframe.contentWindow) return;

    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func: command,
        args: args || []
      }),
      "*"
    );
  }

  function clearElement(element) {
    while (element && element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  function getSourceData(root, variant) {
    var source = root.querySelector('[data-nc-flame-source][data-variant="' + variant + '"]');

    if (!source && variant === "mobile") {
      source = root.querySelector('[data-nc-flame-source][data-variant="desktop"]');
    }

    if (!source) return null;

    var kind = source.getAttribute("data-kind") || "native";
    var url = source.getAttribute("data-url") || "";

    if (kind === "external" && isYouTubeUrl(url)) {
      return {
        kind: "youtube",
        url: url,
        sources: []
      };
    }

    if (kind === "external") {
      return {
        kind: "native",
        url: "",
        sources: [
          {
            src: url,
            type: ""
          }
        ]
      };
    }

    var sourceNodes = Array.prototype.slice.call(source.querySelectorAll("[data-src]"));

    return {
      kind: "native",
      url: "",
      sources: sourceNodes.map(function (node) {
        return {
          src: node.getAttribute("data-src") || "",
          type: node.getAttribute("data-type") || ""
        };
      }).filter(function (item) {
        return item.src;
      })
    };
  }

  function updateRangeBackground(range, value) {
    if (!range) return;

    var amount = Math.max(0, Math.min(1, Number(value) || 0)) * 100;
    range.style.background = "linear-gradient(to right, #f97316 0%, #f97316 " + amount + "%, rgba(255,255,255,0.22) " + amount + "%, rgba(255,255,255,0.22) 100%)";
  }

  function setMutedState(root, isMuted) {
    var state = root.ncFlameAmbianceState;
    if (!state) return;

    state.isMuted = isMuted;
    if (state.panel) {
      state.panel.classList.toggle("nc-flame-ambiance__volume-panel--muted", isMuted);
    }
    if (state.toggle) {
      state.toggle.setAttribute("aria-label", isMuted ? "Turn sound on" : "Turn sound off");
    }
  }

  function setVideoVolume(root, volume) {
    var state = root.ncFlameAmbianceState;
    if (!state) return;

    var nextVolume = Math.max(0, Math.min(1, Number(volume) || 0));
    state.volume = nextVolume;
    setMutedState(root, nextVolume === 0);
    updateRangeBackground(state.range, nextVolume);

    if (state.range) {
        state.range.value = String(nextVolume);
    }

    if (state.video) {
      state.video.volume = nextVolume;
      state.video.muted = nextVolume === 0;
    }

    if (state.iframe) {
      sendYouTubeCommand(state.iframe, nextVolume === 0 ? "mute" : "unMute");
      sendYouTubeCommand(state.iframe, "setVolume", [Math.round(nextVolume * 100)]);
    }
  }

  function openVolumePanel(root) {
    var state = root.ncFlameAmbianceState;
    if (!state || !state.panel || !state.rangeWrap) return;

    state.panel.classList.add("nc-flame-ambiance__volume-panel--open");
    state.rangeWrap.hidden = false;
  }

  function closeVolumePanel(root) {
    var state = root.ncFlameAmbianceState;
    if (!state || !state.panel || !state.rangeWrap) return;

    state.panel.classList.remove("nc-flame-ambiance__volume-panel--open");
    state.rangeWrap.hidden = true;

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }

  function startVolumeCollapseTimer(root) {
    var state = root.ncFlameAmbianceState;
    if (!state) return;

    if (state.collapseTimer) {
      window.clearTimeout(state.collapseTimer);
    }

    state.collapseTimer = window.setTimeout(function () {
      closeVolumePanel(root);
    }, 1500);
  }

  function clearVolumeCollapseTimer(root) {
    var state = root.ncFlameAmbianceState;
    if (state && state.collapseTimer) {
      window.clearTimeout(state.collapseTimer);
      state.collapseTimer = null;
    }
  }

  function hideMedia(state) {
    if (state.video) state.video.hidden = true;
    if (state.iframe) state.iframe.hidden = true;
  }

  function loadSource(root) {
    var state = root.ncFlameAmbianceState;
    if (!state || state.isLoaded) return;

    var data = getSourceData(root, state.isMobile ? "mobile" : "desktop");
    if (!data) return;

    state.isLoaded = true;
    state.activeKind = data.kind;

    if (state.poster) {
      state.poster.hidden = true;
    }

    if (data.kind === "youtube") {
      hideMedia(state);
      if (state.iframe) {
        state.iframe.src = getYouTubeEmbedUrl(data.url);
        state.iframe.hidden = false;
      }
      return;
    }

    if (!state.video || !data.sources.length) return;

    hideMedia(state);
    clearElement(state.video);

    data.sources.forEach(function (item) {
      var source = document.createElement("source");
      source.src = item.src;
      if (item.type) source.type = item.type;
      state.video.appendChild(source);
    });

    var posterUrl = state.isMobile ? state.frame.getAttribute("data-mobile-poster") : state.frame.getAttribute("data-desktop-poster");
    if (posterUrl) {
      state.video.setAttribute("poster", posterUrl);
    } else {
      state.video.removeAttribute("poster");
    }

    state.video.muted = state.volume === 0;
    state.video.volume = state.volume;
    state.video.load();
    state.video.hidden = false;
  }

  function unloadSource(root) {
    var state = root.ncFlameAmbianceState;
    if (!state) return;

    pauseMedia(root);

    if (state.video) {
      clearElement(state.video);
      state.video.removeAttribute("src");
      state.video.load();
      state.video.hidden = true;
    }

    if (state.iframe) {
      state.iframe.removeAttribute("src");
      state.iframe.hidden = true;
    }

    if (state.poster) {
      state.poster.hidden = false;
    }

    state.isLoaded = false;
    state.activeKind = null;
  }

  function playMedia(root) {
    var state = root.ncFlameAmbianceState;
    if (!state) return;

    loadSource(root);

    if (state.activeKind === "youtube" && state.iframe && !state.iframe.hidden) {
      if (state.volume === 0) sendYouTubeCommand(state.iframe, "mute");
      sendYouTubeCommand(state.iframe, "playVideo");
      return;
    }

    if (state.video && !state.video.hidden) {
      state.video.play().catch(function () {});
    }
  }

  function pauseMedia(root) {
    var state = root.ncFlameAmbianceState;
    if (!state) return;

    if (state.video) {
      state.video.pause();
    }

    if (state.iframe) {
      sendYouTubeCommand(state.iframe, "pauseVideo");
    }
  }

  function handleViewportChange(root) {
    var state = root.ncFlameAmbianceState;
    if (!state || !state.mediaQuery) return;

    var nextIsMobile = state.mediaQuery.matches;
    if (nextIsMobile === state.isMobile) return;

    state.isMobile = nextIsMobile;
    unloadSource(root);

    if (state.shouldLoad) {
      loadSource(root);
    }

    if (state.isInView) {
      playMedia(root);
    }
  }

  function resetRoot(root) {
    var state = root && root.ncFlameAmbianceState;
    if (!state) return;

    clearVolumeCollapseTimer(root);
    if (state.preloadObserver) state.preloadObserver.disconnect();
    if (state.playObserver) state.playObserver.disconnect();
    if (state.mediaQuery) state.mediaQuery.removeEventListener("change", state.handlers.viewportChange);
    if (state.toggle) state.toggle.removeEventListener("click", state.handlers.toggleClick);
    if (state.range) {
      state.range.removeEventListener("input", state.handlers.rangeInput);
      state.range.removeEventListener("mousedown", state.handlers.rangeStart);
      state.range.removeEventListener("mouseup", state.handlers.rangeEnd);
      state.range.removeEventListener("touchstart", state.handlers.rangeStart);
      state.range.removeEventListener("touchend", state.handlers.rangeEnd);
    }

    unloadSource(root);
    delete root.ncFlameAmbianceState;
    delete root.dataset.ncFlameAmbianceInitialized;
  }

  function initRoot(root) {
    if (!root || root.dataset.ncFlameAmbianceInitialized === "true") return;

    var frame = root.querySelector("[data-nc-flame-video-frame]");
    if (!frame) return;

    var mediaQuery = window.matchMedia ? window.matchMedia("(max-width: 767px)") : null;
    var state = {
      frame: frame,
      video: root.querySelector("[data-nc-flame-video]"),
      iframe: root.querySelector("[data-nc-flame-iframe]"),
      poster: root.querySelector("[data-nc-flame-poster]"),
      panel: root.querySelector("[data-nc-flame-volume-panel]"),
      toggle: root.querySelector("[data-nc-flame-volume-toggle]"),
      range: root.querySelector("[data-nc-flame-volume-range]"),
      rangeWrap: root.querySelector("[data-nc-flame-range-wrap]"),
      mediaQuery: mediaQuery,
      isMobile: mediaQuery ? mediaQuery.matches : false,
      isLoaded: false,
      isInView: false,
      shouldLoad: false,
      activeKind: null,
      volume: 0,
      isMuted: true,
      collapseTimer: null,
      handlers: {}
    };

    state.handlers.viewportChange = function () {
      handleViewportChange(root);
    };

    state.handlers.toggleClick = function () {
      openVolumePanel(root);
      startVolumeCollapseTimer(root);

      if (state.isMuted || state.volume === 0) {
        setVideoVolume(root, 1);
        playMedia(root);
      } else {
        setVideoVolume(root, 0);
      }
    };

    state.handlers.rangeInput = function (event) {
      var nextVolume = Number(event.currentTarget.value);
      openVolumePanel(root);
      startVolumeCollapseTimer(root);
      setVideoVolume(root, nextVolume);

      if (nextVolume > 0) {
        playMedia(root);
      }
    };

    state.handlers.rangeStart = function () {
      clearVolumeCollapseTimer(root);
    };

    state.handlers.rangeEnd = function () {
      startVolumeCollapseTimer(root);
    };

    root.ncFlameAmbianceState = state;
    root.dataset.ncFlameAmbianceInitialized = "true";

    if (state.mediaQuery) {
      state.mediaQuery.addEventListener("change", state.handlers.viewportChange);
    }

    if (state.toggle) {
      state.toggle.addEventListener("click", state.handlers.toggleClick);
    }

    if (state.range) {
      state.range.addEventListener("input", state.handlers.rangeInput);
      state.range.addEventListener("mousedown", state.handlers.rangeStart);
      state.range.addEventListener("mouseup", state.handlers.rangeEnd);
      state.range.addEventListener("touchstart", state.handlers.rangeStart);
      state.range.addEventListener("touchend", state.handlers.rangeEnd);
      updateRangeBackground(state.range, 0);
    }

    setMutedState(root, true);

    if ("IntersectionObserver" in window) {
      state.preloadObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              state.shouldLoad = true;
              loadSource(root);
            }
          });
        },
        { root: null, rootMargin: "300px 0px", threshold: 0 }
      );

      state.playObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            state.isInView = entry.isIntersecting;

            if (entry.isIntersecting) {
              playMedia(root);
            } else {
              pauseMedia(root);
            }
          });
        },
        { root: null, threshold: 0.25 }
      );

      state.preloadObserver.observe(frame);
      state.playObserver.observe(frame);
    } else {
      state.shouldLoad = true;
      loadSource(root);
    }
  }

  function initAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-flame-ambiance]")
      : [];

    if (scope.matches && scope.matches("[data-nc-flame-ambiance]")) {
      initRoot(scope);
    }

    roots.forEach(initRoot);
  }

  function resetAll(context) {
    var scope = context || document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-nc-flame-ambiance]")
      : [];

    if (scope.matches && scope.matches("[data-nc-flame-ambiance]")) {
      resetRoot(scope);
    }

    roots.forEach(resetRoot);
  }

  api.initAll = initAll;
  api.resetAll = resetAll;
  window.NCFlameAmbiance = api;

  if (!window.__ncFlameAmbianceEventsBound) {
    window.__ncFlameAmbianceEventsBound = true;

    document.addEventListener("DOMContentLoaded", function () {
      window.NCFlameAmbiance.initAll(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      window.NCFlameAmbiance.initAll(event.target);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      window.NCFlameAmbiance.resetAll(event.target);
    });
  }

  if (document.readyState !== "loading") {
    window.NCFlameAmbiance.initAll(document);
  }
})();
